import React from "react";
import "./button.css";
import PropTypes from "prop-types";

export default class Button extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let {children, width, height, type, onClick} = this.props;
        return (
            type === "primary"?
                <button className="anygen-btn" onClick={onClick}>
                    <div className="anygen-btn-inner-section" >
                        {children}
                    </div>
                </button>
                :
                type === "secondary"?
                <button className="anygen-btn secondary" onClick={onClick}>
                    <div className="anygen-btn-border"/>
                    <div className="anygen-btn-inner-section">
                        {children}
                    </div>
                </button>
                    :
                    <button className="anygen-btn custom" onClick={onClick}>
                        <div className="anygen-btn-inner-section">
                            {children}
                        </div>
                    </button>
        );
    }
}

Button.defaultProps = {
    width: "auto",
    height: "40px",
    type: "primary"
}
Button.propType = {
    width: PropTypes.string,
    height: PropTypes.string,
    type: PropTypes.oneOf(["primary","secondary"])
}